import { createContext, useContext, type ReactNode } from 'react';
import { useCurrentUser } from '../api/auth';
import type { User } from '../types';

interface AuthContextType {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: ReactNode }): JSX.Element {
  const { data: user, isLoading, isError } = useCurrentUser();

  const value: AuthContextType = {
    user: isError ? null : user ?? null,
    isLoading,
    isAuthenticated: !!user && !isError,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
